<div id="toolbarViewerMiddle" [class]="showZoomButtons | responsiveCSSClass : 'always-visible'">
  <pdf-zoom-out [showZoomButtons]="showZoomButtons"></pdf-zoom-out>
  <pdf-zoom-in [showZoomButtons]="showZoomButtons"></pdf-zoom-in>
  <pdf-zoom-dropdown style="width: unset; max-width: unset; padding-top: 3px" [zoomLevels]="zoomLevels"> </pdf-zoom-dropdown>
</div>
